/* eslint-disable import/prefer-default-export */
export enum AdsType {
  INCREMENT_COUNTER = 'AdsType/INCREMENT_COUNTER',
  RESET_INTERSTITIAL = 'AdsType/RESET_INTERSTITIAL',
  RESET_REWARD = 'AdsType/RESET_REWARD',
  SET_DEFAULT_VALUE = 'AdsType/SET_DEFAULT_VALUE'
}
